module.exports = __webpack_public_path__ + "static/media/lightbulb.c4726770.svg";